import React, { Suspense, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ResultModal from '../../../Components/Modal/ResultModal.component';
import {
  SubmitContainer,
  TopSubmit,
  BottomSubmit,
} from '../../CreateRoutes/CreateForm.styles';
import EditUserSubmit from '../EditUser/EditUserPage/Buttons/UserEditSubmit.component';
import ActivateUserButton from '../EditUser/EditUserPage/Buttons/UserEditActivate.component';
import DeleteUserButton from '../EditUser/EditUserPage/Buttons/UserEditDelete.component';
import DisableUserButton from '../EditUser/EditUserPage/Buttons/UserEditDisable.component';
const UserDetailSection = React.lazy(
  () => import('./DetailsSection.component')
);
import ManagerEmployeeInput from '../../../Components/UserForm/ManagerEmployeeInputs.component';

const EditManagerOrEmployeeInner = ({ user, userId }) => {
  const [successState, setSuccessState] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [userEdited, setUserEdited] = useState([]);
  const [type, setType] = useState();
  useEffect(() => {
    if (user) {
      setUserEdited(user);
      setType(user?.type);
    }
  }, [user, userId]);

  return (
    <>
      <h2>Edit Manager / Employee</h2>
      <ManagerEmployeeInput
        user={userEdited}
        setUser={setUserEdited}
        type={type}
        setType={setType}
        showType={true}
      />
      <Suspense fallback={<p>Loading user details...</p>}>
        <UserDetailSection user={user} />
      </Suspense>
      <SubmitContainer>
        <TopSubmit>
          {successState.length > 0 && <p className="result">{successState}</p>}
        </TopSubmit>
        <BottomSubmit>
          <Suspense fallback={<p>Loading delete button...</p>}>
            <DeleteUserButton
              id={userId}
              setSuccessState={setSuccessState}
              setIsOpen={setIsOpen}
            />
          </Suspense>
          <Suspense fallback={<p>Loading activation/deactivation button...</p>}>
            {user?.active ? (
              <DisableUserButton
                id={userId}
                setSuccessState={setSuccessState}
                setIsOpen={setIsOpen}
              />
            ) : (
              <ActivateUserButton
                id={userId}
                setSuccessState={setSuccessState}
                setIsOpen={setIsOpen}
              />
            )}
          </Suspense>
          <Suspense fallback={<p>Loading submit button...</p>}>
            <EditUserSubmit
              user={userEdited}
              type={type}
              successState={successState}
              setSuccessState={setSuccessState}
              setIsOpen={setIsOpen}
            />
          </Suspense>
        </BottomSubmit>
      </SubmitContainer>
      <ResultModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        result={successState}
        linkTo="/admin"
      />
    </>
  );
};
EditManagerOrEmployeeInner.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    active: PropTypes.bool,
  }),
  userId: PropTypes.string,
};

export default EditManagerOrEmployeeInner;
